// ABOUTME: Toolbar with search input, category filter, and shop selector for the config page.
// ABOUTME: Provides filtering controls for the product and category config tables.

import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { colors } from '../../theme/colors';

export default function ConfigSearchToolbar({
  searchQuery,
  onSearchChange,
  categoryFilter,
  onCategoryFilterChange,
  categories = [],
  selectedShopId,
  onShopChange,
  shops = [],
  showShopSelector = true,
  showCategoryFilter = true,
  searchPlaceholder,
  onAddProduct,
  showAddProduct = false,
  onAddCategory,
  showAddCategory = false,
}) {
  const { t } = useTranslation();

  return (
    <Box sx={{
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      mb: 2,
      flexWrap: 'wrap',
    }}>
      {showShopSelector && shops.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>{t('config.shopLabel')}</InputLabel>
          <Select
            value={selectedShopId || ''}
            onChange={(e) => onShopChange(e.target.value)}
            label={t('config.shopLabel')}
            sx={{ borderRadius: '8px' }}
          >
            {shops.map(shop => (
              <MenuItem key={shop.shop_id} value={shop.shop_id}>
                {shop.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      <TextField
        size="small"
        placeholder={searchPlaceholder || t('config.search')}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          flex: 1,
          minWidth: 200,
          maxWidth: 400,
          '& .MuiOutlinedInput-root': { borderRadius: '8px' },
        }}
      />

      {showCategoryFilter && categories.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>{t('config.fields.category')}</InputLabel>
          <Select
            value={categoryFilter || 'all'}
            onChange={(e) => onCategoryFilterChange(e.target.value)}
            label={t('config.fields.category')}
            sx={{ borderRadius: '8px' }}
          >
            <MenuItem value="all">{t('config.allCategories')}</MenuItem>
            {categories.map(cat => (
              <MenuItem key={cat.id} value={cat.id}>
                <Box component="span" sx={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  backgroundColor: cat.color || colors.category.default,
                  display: 'inline-block',
                  mr: 1,
                }} />
                {cat.name || cat.id}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {showAddProduct && onAddProduct && (
        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={onAddProduct}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.8rem',
            borderRadius: '8px',
            border: `1px solid ${colors.border.light}`,
            color: colors.text.secondary,
            '&:hover': { backgroundColor: colors.background.hover, borderColor: colors.text.secondary },
            ml: 'auto',
          }}
        >
          {t('config.product.addProduct')}
        </Button>
      )}

      {showAddCategory && onAddCategory && (
        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={onAddCategory}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.8rem',
            borderRadius: '8px',
            border: `1px solid ${colors.border.light}`,
            color: colors.text.secondary,
            '&:hover': { backgroundColor: colors.background.hover, borderColor: colors.text.secondary },
            ml: 'auto',
          }}
        >
          {t('config.category.addCategory')}
        </Button>
      )}
    </Box>
  );
}
